import { render, staticRenderFns } from "./TransgressiveUsers.vue?vue&type=template&id=1482b92e&scoped=true&"
import script from "./TransgressiveUsers.vue?vue&type=script&lang=js&"
export * from "./TransgressiveUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482b92e",
  null
  
)

export default component.exports